import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notificationApi } from '../api/notification.api';
import { notificationKeys } from '../api/notification.keys';
import toast from 'react-hot-toast';

export function useCreateNotification() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => notificationApi.create(data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: notificationKeys.all });
      toast.success('Notification created');
    },
    onError: (err: any) => {
      toast.error(err.response?.data?.message || 'Failed to create notification');
    },
  });
}

export function useUpdateNotification() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: any) => notificationApi.update(id, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: notificationKeys.all });
      toast.success('Notification updated');
    },
    onError: (err: any) => {
      toast.error(err.response?.data?.message || 'Failed to update notification');
    },
  });
}

export function useDeleteNotification() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: any) => notificationApi.delete(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: notificationKeys.all });
      toast.success('Notification deleted');
    },
    onError: (err: any) => {
      toast.error(err.response?.data?.message || 'Failed to delete notification');
    },
  });
}
